import { DateUtil, QwLanguageKeys } from './core';

let arrivalDate =
  window.QW_HOTEL_ENV.ARRIVAL_DATE ||
  DateUtil.getDateStringFromDate(
    DateUtil.addDaysToDate(7, DateUtil.removeTimeFromDate(new Date()))
  );
let departureDate =
  window.QW_HOTEL_ENV.DEPARTURE_DATE ||
  DateUtil.getDateStringFromDate(
    DateUtil.addDaysToDate(8, DateUtil.removeTimeFromDate(new Date()))
  );

// if date is somehow in the past  lets set it to today and preserve the original # of days difference possibly set in env.
const days =
  ((new Date(departureDate).getTime() - new Date(arrivalDate).getTime()) /
    86400000) |
  0;
const today = DateUtil.removeTimeFromDate(new Date());
if (new Date(arrivalDate).getTime() < today.getTime()) {
  arrivalDate = DateUtil.getDateStringFromDate(today);
  departureDate = DateUtil.getDateStringFromDate(
    DateUtil.addDaysToDate(days, today)
  );
}

export const Env = {
  WebSdkToken: window.QW_HOTEL_ENV.WEBSDK_TOKEN,
  WebSdkHotelId: window.QW_HOTEL_ENV.WEBSDK_HOTEL_ID,
  WebSdkBaseUrl: window.QW_HOTEL_ENV.WEBSDK_BASE_URL,
  Endpoint: window.QW_HOTEL_ENV.ENDPOINT,
  EngineId: window.QW_HOTEL_ENV.ENGINE_ID,
  Currency: window.QW_HOTEL_ENV.CURRENCY || 'EUR',
  Country: window.QW_HOTEL_ENV.COUNTRY || 'FR',
  DefaultLanguage: window.QW_HOTEL_ENV.LANGUAGE || QwLanguageKeys.en,
  DefaultNumberOfGuests: window.QW_HOTEL_ENV.GUESTS || 1,
  DefaultNumberOfAdults: window.QW_HOTEL_ENV.ADULTS || 2,
  DefaultNumberOfChildren: window.QW_HOTEL_ENV.CHILDREN || 0,
  DefaultNumberOfInfants: window.QW_HOTEL_ENV.INFANTS || 0,
  DefaultArrivalDate: arrivalDate,
  DefaultDepartureDate: departureDate,
  HotelId: window.QW_HOTEL_ENV.HOTEL_ID || undefined,
  IsMonoHotel:
    window.QW_HOTEL_ENV.IS_MONO_HOTEL !== undefined
      ? window.QW_HOTEL_ENV.IS_MONO_HOTEL
      : false,
  SessionIdCookieKey: window.QW_HOTEL_ENV.SESSION_ID_COOKIE_KEY || 'fusionId',
  SessionMetadata: window.QW_HOTEL_ENV.SESSION_METADATA || {},
};
